import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SrIcon } from "@/components/ui/SrIcon";

export interface InvoiceLine {
  id: string;
  description: string;
  quantity: number;
  unit_price: number;
  line_type: "Normal" | "Text";
}

interface InvoiceLinesEditorProps {
  lines: InvoiceLine[];
  onUpdate: (id: string, field: keyof InvoiceLine, value: string | number) => void;
  onAdd: () => void;
  onAddText: () => void;
  onRemove: (id: string) => void;
}

/** Fakturalinjer i opprett-faktura-dialogen: beløpslinjer og fritekstlinjer. */
export function InvoiceLinesEditor({
  lines,
  onUpdate,
  onAdd,
  onAddText,
  onRemove,
}: InvoiceLinesEditorProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <label className="text-xs text-muted-foreground font-medium">Fakturalinjer</label>
        <div className="flex gap-1">
          <Button variant="ghost" size="sm" className="h-6 text-xs px-2" onClick={onAddText}>
            <SrIcon name="plus" className="w-3 h-3 mr-1"  /> Fritekst
          </Button>
          <Button variant="ghost" size="sm" className="h-6 text-xs px-2" onClick={onAdd}>
            <SrIcon name="plus" className="w-3 h-3 mr-1"  /> Linje
          </Button>
        </div>
      </div>
      <div className="space-y-2">
        <div className="grid grid-cols-[1fr_70px_100px_28px] gap-2 text-[11px] text-muted-foreground px-1">
          <span>Beskrivelse</span>
          <span className="text-right">Antall</span>
          <span className="text-right">Enhetspris</span>
          <span />
        </div>
        {lines.map((line) =>
          line.line_type === "Text" ? (
            <div key={line.id} className="grid grid-cols-[1fr_28px] gap-2 items-center">
              <Input
                className="h-8 text-sm italic text-muted-foreground"
                value={line.description}
                onChange={(e) => onUpdate(line.id, "description", e.target.value)}
                placeholder="Fritekst (vises uten beløp)"
              />
              <button
                className="h-8 w-7 flex items-center justify-center text-muted-foreground hover:text-destructive"
                onClick={() => onRemove(line.id)}
              >
                <SrIcon name="trash2" className="w-3.5 h-3.5"  />
              </button>
            </div>
          ) : (
            <div key={line.id} className="grid grid-cols-[1fr_70px_100px_28px] gap-2 items-center">
              <Input
                className="h-8 text-sm"
                value={line.description}
                onChange={(e) => onUpdate(line.id, "description", e.target.value)}
                placeholder="Beskrivelse"
              />
              <Input
                type="number"
                className="h-8 text-sm text-right"
                value={line.quantity}
                onChange={(e) => onUpdate(line.id, "quantity", Number(e.target.value))}
              />
              <Input
                type="number"
                className="h-8 text-sm text-right"
                value={line.unit_price}
                onChange={(e) => onUpdate(line.id, "unit_price", Number(e.target.value))}
              />
              <button
                className="h-8 w-7 flex items-center justify-center text-muted-foreground hover:text-destructive disabled:opacity-30"
                onClick={() => onRemove(line.id)}
                disabled={lines.length <= 1}
              >
                <SrIcon name="trash2" className="w-3.5 h-3.5"  />
              </button>
            </div>
          )
        )}
      </div>
    </div>
  );
}
